module.exports = __webpack_public_path__ + "img/9444560.webp";